module.exports = __webpack_public_path__ + "static/media/baikor.272ab494.png";